import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/gallery/public/:gallerySlug',
		name: 'PublicGallery',
		component: () => import('@/views/PublicGallery.vue'),
		props: true,
		meta: {
			requiresAuth: false,
			layout: 'LayoutDefault',
			title: 'publicGalleryPage.metaTitle',
		},
	},
];

export default routes;
